import {getCalculatorType, numberToCurrency} from "./helpers";
import {parseSearchQuery} from "../store/actions/calculatorActions";
import {store} from "../index";

export const getStepParams = () => {

  const requestParams = parseSearchQuery(window.location.search, true);
  const stateStore = getStateFromStore();
  if (isStateSharedViaUrl() || isStateSavedInSession() || requestParams) {
    return stateStore;
  }
}

export const getStep1HeaderSummary = (ApplicantYearlyIncome, HasPartner, PartnerYearlyIncome) => {
  if (typeof ApplicantYearlyIncome !== 'undefined' || ApplicantYearlyIncome > 0) {
    return numberToCurrency((typeof PartnerYearlyIncome !== "undefined" && HasPartner
    ? +PartnerYearlyIncome + +ApplicantYearlyIncome
    : +ApplicantYearlyIncome));
  }
}

export const getStep2HeaderSummary = (HasLoans, Loans, Alimony, StudentDebtMonthlyPayment, PrivateLeaseAmount, intl) => {
  const sum = +Loans + +Alimony + +StudentDebtMonthlyPayment + +PrivateLeaseAmount;
  return HasLoans === "1" ? numberToCurrency(sum) : intl.formatMessage({
    id: 'step2.headerSummary.no',
    defaultMessage: 'Nee',
  });
}

export const getStep3HeaderSummary = (Woning, intl) => {
  return Woning <= 0 ? intl.formatMessage({
    id: 'step3.headerSummary.no',
    defaultMessage: 'Nee',
  }) : numberToCurrency(Woning);
}

export const getStep4HeaderSummary = (HomeEquity, OwnResources, HomeEquityCosts, HomeMortgageAmount, Woning, returnAsInteger, intl) => {
  let sum = HomeEquity ? HomeEquity : 0;
  //if (Woning > 0) {
    sum = HomeEquity ? (+OwnResources + (+HomeEquity - +HomeEquityCosts - +HomeMortgageAmount)) : +OwnResources;
  //}

  if (!returnAsInteger) {
    //The amount should be (selling price - costs to sell the house - remaining value of current mortgage) + eigen geld
    return (sum > 0 || sum < 0) ? numberToCurrency(sum) : intl.formatMessage({
      id: 'step4.headerSummary.no',
      defaultMessage: 'Nee',
    });
  } else {
    return sum;
  }
}

export const getStep5HeaderSummary = (MortgageType, intl) => {
  return  MortgageType === "Annuïteitenhypotheek" || MortgageType === "Annuiteitenhypotheek" ? intl.formatMessage({
    id: 'step5.headerSummary.annuïteiten',
    defaultMessage: 'Annuïteiten',
  }) : intl.formatMessage({
    id: 'step5.headerSummary.lineair',
    defaultMessage: 'Lineair',
  });
}


const isStateSharedViaUrl = () => {
  const req = parseSearchQuery(window.location.search);
  if (req && req.share) {
    return true;
  }
}


const isStateSavedInSession = () => {
  if (window.localStorage.getItem(`state.${getCalculatorType()}`)) {
    return true;
  }
}
const getStateFromStore = () => {
  return store.getState().calculator;
}


